import { Helmet } from "react-helmet-async";
 import  {AssignedListViewReport}  from "../../../sections/company/report/assignedReport/index.js";

export default function AssignedListViewReportPage(){
    return (
        <>
            <Helmet>
                <title>Trainer/Assessor Course Assigned Report Page</title>
            </Helmet>
            <AssignedListViewReport />
        </>
    )
}